const axios = require('axios');

export const callAxios = async (method, url, data) => {
    const { data: responseData } = await axios({
        method,
        url,
        data,
    });
    return responseData;
};
